/* tslint:disable */

declare var Object: any;
export interface LogInterface {
  "level": string;
  "message": string;
  "meta": string;
  "timestamp": Date;
  "id"?: number;
}

export class Log implements LogInterface {
  "level": string;
  "message": string;
  "meta": string;
  "timestamp": Date;
  "id": number;
  constructor(data?: LogInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Log`.
   */
  public static getModelName() {
    return "Log";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Log for dynamic purposes.
  **/
  public static factory(data: LogInterface): Log{
    return new Log(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Log',
      plural: 'Logs',
      path: 'Logs',
      idName: 'id',
      properties: {
        "level": {
          name: 'level',
          type: 'string'
        },
        "message": {
          name: 'message',
          type: 'string'
        },
        "meta": {
          name: 'meta',
          type: 'string'
        },
        "timestamp": {
          name: 'timestamp',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Log.ts